export function statParamToName(stat: string) {
    switch (stat) {
        // Estatísticas Básicas
        case 'GOALS':
            return 'names.names_1';
        case 'ASSISTS':
            return 'names.names_2';
        case 'MINUTES_PLAYED':
            return 'names.names_3';
        case 'RATING':
            return 'names.names_4';
        case 'TOUCHES':
            return 'names.names_5';
        case 'APPEARANCES':
            return 'names.names_6';

        // Finalizações
        case 'SHOTS_TOTAL':
            return 'names.names_7';
        case 'SHOTS_ON_TARGET':
            return 'names.names_8';
        case 'SHOTS_OFF_TARGET':
            return 'names.names_9';
        case 'SHOTS_BLOCKED':
            return 'names.names_10';
        case 'BLOCKED_SHOTS':
            return 'names.names_11';
        case 'BIG_CHANCES_MISSED':
            return 'names.names_12';
        case 'HIT_WOODWORK':
            return 'names.names_13';

        // Passes
        case 'PASSES':
            return 'names.names_14';
        case 'ACCURATE_PASSES':
            return 'names.names_15';
        case 'ACCURATE_PASSES_PERCENTAGE':
            return 'names.names_16';
        case 'KEY_PASSES':
            return 'names.names_17';
        case 'LONG_BALLS':
            return 'names.names_18';
        case 'LONG_BALLS_WON':
            return 'names.names_19';
        case 'THROUGH_BALLS':
            return 'names.names_20';
        case 'THROUGH_BALLS_WON':
            return 'names.names_21';

        // Cruzamentos
        case 'TOTAL_CROSSES':
            return 'names.names_22';
        case 'ACCURATE_CROSSES':
            return 'names.names_23';
        case 'CORNERS':
            return 'names.names_24';

        // Disputas
        case 'TOTAL_DUELS':
            return 'names.names_25';
        case 'DUELS_TOTAL':
            return 'names.names_26';
        case 'DUELS_WON':
            return 'names.names_27';
        case 'DUELS_LOST':
            return 'names.names_28';
        case 'AERIALS_WON':
            return 'names.names_29';
        case 'AERIALS_LOST':
            return 'names.names_30';

        // Dribles
        case 'DRIBBLED_ATTEMPTS':
            return 'names.names_31';
        case 'SUCCESSFUL_DRIBBLES':
            return 'names.names_32';
        case 'DRIBBLED_PAST':
            return 'names.names_33';
        case 'DISPOSSESSED':
            return 'names.names_34';

        // Defesa
        case 'TACKLES':
            return 'names.names_35';
        case 'INTERCEPTIONS':
            return 'names.names_36';
        case 'CLEARANCES':
            return 'names.names_37';
        case 'CLEARANCE_OFFLINE':
            return 'names.names_38';

        // Faltas e Cartões
        case 'FOULS':
            return 'names.names_39';
        case 'FOULS_DRAWN':
            return 'names.names_40';
        case 'YELLOWCARDS':
            return 'names.names_41';
        case 'REDCARDS':
            return 'names.names_42';
        case 'YELLOWRED_CARDS':
            return 'names.names_43';

        // Goleiro
        case 'SAVES':
            return 'names.names_44';
        case 'SAVES_INSIDE_BOX':
            return 'names.names_45';
        case 'GOALKEEPER_GOALS_CONCEDED':
            return 'names.names_46';
        case 'GOALS_CONCEDED':
            return 'names.names_47';
        case 'PUNCHES':
            return 'names.names_48';

        // Criação de Jogadas
        case 'BIG_CHANCES_CREATED':
            return 'names.names_49';
        case 'BALL_POSSESSION':
            return 'names.names_50';

        // Pênaltis
        case 'PENALTIES_SCORED':
            return 'names.names_51';
        case 'PENALTIES_MISSES':
            return 'names.names_52';
        case 'PENALTIES_COMMITTED':
            return 'names.names_53';
        case 'PENALTIES_WON':
            return 'names.names_54';
        case 'PENALTIES_SAVED':
            return 'names.names_55';

        // Outros
        case 'CAPTAIN':
            return 'names.names_56';
        case 'OFFSIDES':
            return 'names.names_57';
        case 'OWN_GOALS':
            return 'names.names_58';
        case 'ERROR_LEAD_TO_GOAL':
            return 'names.names_59';
        case 'GOAL_KICKS':
            return 'names.names_60';
        case 'DANGEROUS_ATTACKS':
            return 'names.names_61';
        case 'CLEANSHEET':
            return 'names.names_62';

        default:
            return stat;
    }
}